module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-en.2ead5fb2.mp4";